import { Contract as DraftProtos } from '@qover-private/protos-web/qover/dojo/bike/v1/contract';
import { DraftMapper } from '@qover/domain';
import { Draft } from '../Draft';
import * as RiskMapper from './riskMapper';
import * as TermsMapper from './termsMapper';

export function mapToApiRequest(draft: Draft): DraftProtos {
  const risk = RiskMapper.mapToApiRequest(draft.risk);
  const terms = TermsMapper.mapToApiRequest(draft.terms);
  const draftRequest = DraftMapper.mapToApiRequest(draft);

  return {
    ...draftRequest,
    risk,
    terms,
    previousVersions: [],
    nextVersion: undefined,
  };
}
